export default function Rays() {
  return (
    <svg
      id="Group_Copy_2"
      data-name="Group Copy 2"
      xmlns="http://www.w3.org/2000/svg"
      width="74"
      height="140.938"
      viewBox="0 0 74 140.938"
    >
      <path
        id="Fill_1_Copy_4"
        data-name="Fill 1 Copy 4"
        d="M34.323.159c-3.514,2.854-7.045,5.687-10.516,8.595-3.429,2.871-6.767,5.851-10.126,8.8-1.526,1.341-3.011,2.73-4.534,4.074-.8.7-1.584,1.418-2.421,2.075-.9.709-1.8,1.421-2.725,2.1Q2.449,26.953.869,28.055a1.838,1.838,0,0,0-.619.91,4.523,4.523,0,0,0-.179,2.3,3.178,3.178,0,0,0,.452,1.246c.267.368.7.669,1.143.361,1.946-1.35,3.848-2.754,5.725-4.2,1.595-1.23,3.1-2.582,4.614-3.91q4.977-4.356,10.1-8.535c3.43-2.81,6.912-5.554,10.379-8.317l2.755-2.194a2.121,2.121,0,0,0,.714-1.05,5.211,5.211,0,0,0,.206-2.656A3.666,3.666,0,0,0,35.642.574a1.25,1.25,0,0,0-.9-.574.658.658,0,0,0-.422.159"
        fill="#161616"
      />
      <path
        id="Fill_3_Copy"
        data-name="Fill 3 Copy"
        d="M42.966.091a.587.587,0,0,1,.362.036.656.656,0,0,1,.276.26l.156.44A3.234,3.234,0,0,1,43.7,2.072a4.332,4.332,0,0,1-.915,1.921,1.566,1.566,0,0,1-.8.556c-.495.015-.99.028-1.485.04-4.3.106-8.595.139-12.891.247-1.032.026-2.071.017-3.1.081l-3.929.247c-1,.062-1.988.183-2.98.282l-1.656.166c-.4.039-.8.122-1.192.183-1.053.163-2.117.29-3.162.506L9.47,6.739c-.483.1-.973.18-1.452.3-1.078.267-2.157.54-3.235.807-.538.133-1.069.311-1.6.466q-1.113.323-2.221.662C.437,9.132.138,8.565.041,8.12a3.745,3.745,0,0,1,.065-1.44,5.01,5.01,0,0,1,1.06-2.225,1.81,1.81,0,0,1,.926-.644c.513-.156,1.025-.312,1.54-.46,2.072-.6,4.15-1.167,6.262-1.58l2.265-.443c.325-.063.648-.136.974-.182L16.947.6c.34-.048.686-.062,1.029-.092l2.317-.2c.922-.079,1.843-.121,2.768-.162C24.023.11,24.987.043,25.95.036L30.2.006c2.024-.015,4.048,0,6.072.009C38.5.022,40.737.018,42.966.091Z"
        transform="translate(30.204 55.5)"
        fill="#161616"
      />
      <g
        id="Group_7_Copy_2"
        data-name="Group 7 Copy 2"
        transform="translate(7.551 99)"
      >
        <path
          id="Fill_5"
          data-name="Fill 5"
          d="M45.742,0C43.568.148,41.4.368,39.23.577c-1.05.1-2.1.193-3.15.308-1.181.131-2.372.226-3.547.393l-3.469.492c-1.168.166-2.329.405-3.49.608-.9.157-1.794.342-2.691.531-1.007.212-2.016.413-3.02.641q-3.556.81-7.109,1.637c-1.991.464-3.994.9-6.015,1.223-1.726.277-3.454.522-5.185.764a1.169,1.169,0,0,0-.919.573A4.06,4.06,0,0,0,0,10.146,4.959,4.959,0,0,0,.3,11.9l.337.644a1.174,1.174,0,0,0,.92.574c1.2-.166,2.4-.316,3.595-.5,1.045-.165,2.1-.3,3.137-.511,1.128-.231,2.264-.436,3.386-.693l3.764-.861c1.888-.431,3.778-.858,5.675-1.248,1.16-.239,2.317-.514,3.485-.717l3.775-.658c4.109-.716,8.259-1.162,12.4-1.639q2.484-.287,4.966-.58a1.122,1.122,0,0,0,.883-.55,3.9,3.9,0,0,0,.61-2.3,4.781,4.781,0,0,0-.29-1.685C46.778.747,46.4,0,45.792,0l-.05,0"
          transform="translate(9.914 0.094) rotate(43)"
          fill="#161616"
        />
      </g>
    </svg>
  )
}
